import Factory from '../utils/factory'

export default Factory({
  author: null,
  message: '',
  createdAt: null,
  isNew: true,
})
